import React, { useState } from "react";
import { useQuery } from "react-query";
import { deleteCategories, getCategories, updateCategories } from "../../../MyApi/product/categories";
import DataTable from "../../UI/table/DataTable";
import TableActions from "../../UI/table/TableActions";
import StatusBadge from "../../UI/statusBadge";
import StoreCategoryModal from "../../../pages/systemsettings/categories/storeModal";
import i18next from "i18next";
import FilterBar from "../../UI/filterbar";

const CategoriesInfo = ({ id, name }) => {
  const [current_page, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [modalId, setModalId] = useState(null);
  const [filters,setFilters]=useState({})
  const lang = i18next.language;

  const { data, isLoading, refetch, isFetching } = useQuery(
    ["getCategories", id, current_page,filters.search],
    () => getCategories(id ,"","",filters.search),
    {
      keepPreviousData: true,
    }
  );

  const categories = data?.data?.categories || [];
  const totalItems = data?.data?.pagination?.total || 0;
  const lastPage = data?.data?.pagination?.last_page || 0;

  const categoryColumns = [
    { label: "اسم الفئة", accessor: "name" },
    { label: "الاسم المستعار", accessor: "slug" },
    { label: "ترتيب الفئات", accessor: "sort_order" },
    {
      label: "الحالة",
      render: (row) => (
        <StatusBadge status={row.is_active ? "active" : "inactive"} />
      ),
    },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          edit={() => {
            setModalMode("edit");
            setModalId(row.id);
            setIsModalOpen(true);
          }}
          deleteFn={deleteCategories}
          id={row.id}
          refetch={refetch}
          mutationKey={"deleteCategories"}
          deletePermission={"delete_category"}
          editPermission={"update_category"}
          viewPermission={"view_category"}
          togglePermission={"update_category"}
          toggleMutationKey={"update_category"}
          toggleFn={(id, status) =>
            updateCategories({ _method: "PUT", is_active: status, lang }, id)
          }
          is_active={row.is_active}
        />
      ),
    },
  ];

  const onAddClick = () => {
    setModalMode("add");
    setModalId(null);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <FilterBar placeholder={"ابحث بالاسم"}  filters={filters} setFilters={setFilters} filtersConfig={{search:"search"}}/>
      <DataTable
        onAddClick={onAddClick}
        createPermission={"create_category"}
        actionLabel={"إضافة فئات"}
        title={"الفئات"}
        data={categories}
        columns={categoryColumns}
        isLoading={isLoading}
        isFetching={isFetching}
        totalItems={totalItems}
        itemsPerPage={lastPage}
        currentPage={current_page}
        setCurrentPage={setCurrentPage}
      />

      {isModalOpen && (
        <StoreCategoryModal
          refetch={refetch}
          isOpen={isModalOpen}
          toggle={closeModal}
          modalMode={modalMode}
          modalId={modalId}
          initialStoreId={id}
          initialStoreName={name}
        />
      )}
    </div>
  );
};

export default CategoriesInfo;